import { searchFinancialPublication } from '../helpers/filters/financial-publication';
import { search } from './search';

export const FILTER_HUB_FINANCIAL_PUBLICATION_KEY =
  'financial-publication-filter';
export const searchFinancialPublications = search(searchFinancialPublication);
